// Dominios de encurtadores personalizados: normalizacao e casamento por
// subdominio (cadastrar "meulink.co" cobre "go.meulink.co").
const DOMAIN_RE = /^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/;
/** Normaliza entrada livre ("https://www.Bit.ly/abc") para "bit.ly". null = invalido. */
export function normalizeDomain(input) {
    let value = input.trim().toLowerCase();
    value = value.replace(/^[a-z][a-z0-9+.-]*:\/\//, "");
    value = value.split(/[/?#]/, 1)[0] ?? "";
    value = value
        .replace(/:\d+$/, "")
        .replace(/\.$/, "")
        .replace(/^www\./, "");
    return DOMAIN_RE.test(value) ? value : null;
}
/** Normaliza uma lista, descartando invalidos e duplicados (ordem preservada). */
export function normalizeDomainList(domains) {
    const out = [];
    for (const raw of domains) {
        const domain = normalizeDomain(raw);
        if (domain !== null && !out.includes(domain)) {
            out.push(domain);
        }
    }
    return out;
}
/** Host igual ao dominio ou subdominio dele. */
export function hostMatchesDomain(host, domain) {
    const h = host.toLowerCase().replace(/\.$/, "");
    return h === domain || h.endsWith(`.${domain}`);
}
/** Hostname de uma URL, ou null se a URL for invalida. */
export function hostOf(url) {
    try {
        return new URL(url).hostname.toLowerCase();
    }
    catch {
        return null;
    }
}
/** A URL aponta para algum dos dominios cadastrados? */
export function urlMatchesAnyDomain(url, domains) {
    const host = hostOf(url);
    return host !== null && domains.some((d) => hostMatchesDomain(host, d));
}
//# sourceMappingURL=domains.js.map